
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/resources/articles/[articleId]",
      function () {
        return require("private-next-pages/resources/articles/[articleId].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/resources/articles/[articleId]"])
      });
    }
  